import { render, staticRenderFns } from "./report-details.vue?vue&type=template&id=29771922&scoped=true"
import script from "./report-details.vue?vue&type=script&lang=js"
export * from "./report-details.vue?vue&type=script&lang=js"
import style0 from "./report-details.vue?vue&type=style&index=0&id=29771922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29771922",
  null
  
)

export default component.exports